import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M11.083 4.674c1.226-1.109 4.134-1.938 6.615-.057 2.23 1.69 2.172 4.73 1.013 6.19a.75.75 0 0 0 1.175.932c1.639-2.065 1.673-6.078-1.282-8.317-3.158-2.394-6.868-1.361-8.527.14-2.262 2.045-2.55 4.506-2.125 6.085L2.557 14.67A1.75 1.75 0 0 0 2 15.95v2.299c0 .966.784 1.75 1.75 1.75h3.5a.75.75 0 0 0 .75-.75V18h1.25a.75.75 0 0 0 .75-.75V16h1.25a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-1.5 0v1.25H9.25a.75.75 0 0 0-.75.75v1.25H7.25a.75.75 0 0 0-.75.75v1.25H3.75a.25.25 0 0 1-.25-.25v-2.299a.25.25 0 0 1 .08-.183l5.748-5.353a.75.75 0 0 0 .18-.84c-.398-.942-.464-3.057 1.575-4.901Z M17 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-.5 6.5a2.5 2.5 0 0 0-2.5 2.5v3a2.5 2.5 0 0 0 2.5 2.5h3a2.5 2.5 0 0 0 2.5-2.5v-3a2.5 2.5 0 0 0-2.5-2.5h-3Zm3 1.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const KeySecureIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'keySecure'),
) as IconWithRender;

KeySecureIcon.displayName = 'KeySecureIcon';
KeySecureIcon.propTypes = Icon.propTypes;
KeySecureIcon.renderIcon = (props) => <KeySecureIcon {...props} />;
export default KeySecureIcon;
